import React from 'react'
import { RouteObject } from 'react-router-dom'

import { GHLayoutWrapper, GHLayoutProjectWrapper, GlobalPreviewLayout } from './Layout'

export const globalHubCommonRoute: RouteObject = {
  element: <GHLayoutWrapper />,
  children: [
    {
      index: true,
      async lazy() {
        const { default: Component } = await import('./GlobalOverviewPage')
        return {
          Component,
        }
      },
    },
    {
      path: 'projects/:id/edit',
      async lazy() {
        const { default: Component } = await import('./GlobalProjectEditPage')
        return {
          Component,
        }
      },
    },
    {
      path: 'projects/new/:id',
      async lazy() {
        const { default: Component } = await import('./GlobalizeProjectPage')
        return {
          Component,
        }
      },
    },
    {
      path: 'projects/localize/:id',
      async lazy() {
        const { default: Component } = await import('./LocalizeProjectPage')
        return {
          Component,
        }
      },
    },
  ]
}

export const globalHubProjectRoute: RouteObject = {
  element: <GHLayoutProjectWrapper />,
  children: [
    {
      // TODO: DIFFERENT LAYOUT WITH project detail top
      path: 'projects/:id',
      async lazy() {
        const { default: Component } = await import('./GlobalProjectDetailsPage')
        return {
          Component,
        }
      },
    },
  ]
}

export const globalHubPreviewRoute: RouteObject = {
  element: <GlobalPreviewLayout />,
  children: [
    {
      path: 'projects/localize/:id/preview',
      async lazy() {
        const { default: Component } = await import('./LocalizeProjectPreviewPage')
        return {
          Component,
        }
      },
    },
    {
      path: 'projects/new/:id/preview',
      async lazy() {
        const { default: Component } = await import('./GlobalizeProjectPreviewPage')
        return {
          Component,
        }
      },
    }
  ]
}
